//default index file created by jakeCLI 1.0 11:08:57 GMT-0800 (Pacific Standard Time)
export { default as MissingInfoModal } from './MissingInfoModal'
export { default as StyledMissingInfoModal } from './MissingInfoModal.Styled'
